import React from "react";
import "katex/dist/katex.min.css";
import katex from "katex";

export default function AgniTutorMathRenderer({ value, rawText, displayMode = false }) {
  // 1. CRASH FIX: Ensure we never call .replace on undefined
  const textToRender = value || rawText || "";

  if (!textToRender || String(textToRender).trim() === "") {
    return null;
  }

  try {
    // 2. CLEANING: Remove AI-generated markers
    const processedLatex = String(textToRender)
      .replace(/\\\[/g, "")
      .replace(/\\\]/g, "")
      .replace(/\\\(/g, "")
      .replace(/\\\)/g, "")
      .replace(/\$/g, "")
      .trim();

    const html = katex.renderToString(processedLatex, {
      displayMode: displayMode,
      throwOnError: false,
    });

    // 3. NESTING FIX: Use span with inline-block for block math.
    // Using display: "block" inside a <p> (from Markdown) is what causes the error.
    return (
      <span
        className={displayMode ? "math-block-container" : "math-inline-container"}
        style={{
          display: displayMode ? "inline-block" : "inline",
          textAlign: displayMode ? "center" : "left",
          width: displayMode ? "100%" : "auto",
          margin: displayMode ? "1rem 0" : "0",
          verticalAlign: "middle"
        }}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    );
  } catch (error) {
    console.error("Math rendering error:", error);
    return <span>{String(textToRender)}</span>;
  }
}